import {useViewport, withinOrWiderThan} from '@udemy-v2/react-layout-components';
import React from 'react';

import {DarkHeaderMobile} from './dark-header-mobile.react-component';
import {LanguageIcon, Logo} from './dark-header-common.react-component';
import {scrollToSection} from './utils/scroll-to-section';

import styles from './dark-header.module.scss';

export interface NavigationProps {
    showLanguageSelector?: boolean;
    navigationItems: {
        label: string;
        anchorElementId: string;
    }[];
}

const DarkHeader: React.FC<NavigationProps> = ({showLanguageSelector, navigationItems}) => {
    const {range} = useViewport();
    const isWideViewport = range && withinOrWiderThan(range, 'xl');

    if (!navigationItems || navigationItems.length === 0) {
        return null;
    }

    if (!isWideViewport) {
        return <DarkHeaderMobile navigationItems={navigationItems} />;
    }

    const languageSelector = (
        <div className={styles['language-selector']}>
            {showLanguageSelector ? (
                <>
                    <span>EN</span>
                    <LanguageIcon />
                </>
            ) : null}
        </div>
    );

    const handleScroll = (e: React.MouseEvent<HTMLAnchorElement>, anchorElementId: string) => {
        e.preventDefault();

        // Update the URL hash without triggering a page jump
        // Preserve existing query parameters and path
        const url = new URL(window.location.href);
        url.hash = anchorElementId;
        window.history.pushState({}, '', url.toString());

        // Perform smooth scrolling
        scrollToSection(anchorElementId);
    };

    return (
        <nav className={styles.navigation}>
            <Logo />
            <div className={styles['nav-content']}>
                <div className={styles['nav-links']}>
                    {navigationItems.map((item) => (
                        <a
                            key={item.anchorElementId}
                            href={`#${item.anchorElementId}`}
                            onClick={(e) => handleScroll(e, item.anchorElementId)}
                            className={styles['nav-text']}
                        >
                            {item.label}
                        </a>
                    ))}
                </div>
            </div>
            {languageSelector}
        </nav>
    );
};

export default DarkHeader;
